import React from "react";

/** Scrolls to a document of the list by its `[n]`. */
export const scrollToSource = (position: number): void => {
    document.getElementById(`ci-ref-${position}`)?.scrollIntoView({behavior: 'smooth', block: 'center'});
};

/**
 * What a `[n]` does when clicked. The Details tab provides one that opens the
 * collapsed Documents list first; anywhere else it only scrolls.
 */
export const SourceFocusContext = React.createContext<(position: number) => void>(scrollToSource);
